<template>
    <tr>
        <td>{{member.user.first_name}} {{member.user.last_name}} ({{member.user.email}})</td>

        <td>
            <base-select
                v-model="role"
                :options="roles"
                option_label="label"
                option_value="value"
                :disabled="member.is_owner"
                :small="true"/>
        </td>

        <td>
            <template v-if="!member.is_active">
                <base-button
                    v-if="space_permission('SPACE_MEMBER_UPDATE', space)"
                    class="is-small is-primary is-marginless"
                    icon="fas fa-check"
                    text="accept"
                    @click="update"/> &nbsp;

                <base-button
                    v-if="space_permission('SPACE_MEMBER_DELETE', space)"
                    class="is-small is-danger is-marginless"
                    icon="fas fa-times"
                    text="reject"
                    @click="show_confirm = true"/>
            </template>

            <base-button
                v-else-if="space_permission('SPACE_MEMBER_UPDATE', space) && role !== member.role"
                class="is-small is-primary is-marginless"
                icon="fas fa-check"
                text="Save"
                @click="update"/> &nbsp;
        </td>

        <td v-if="space_permission('SPACE_MEMBER_DELETE', space)">
            <i @click="show_confirm = true" v-if="!member.is_owner"
               class="icon fas fa-times-circle"></i>
            <span v-else class="tag is-light">owner</span>
        </td>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to remove this member?"
            @close="show_confirm = false"
            @ok="remove"/>
    </tr>
</template>

<script>
import { roles } from '../../utils/constants';

export default {
    name: 'SpaceMembersItem',
    props: ['member', 'space'],
    data() {
        return { role: this.member.role, roles, show_confirm: false };
    },
    methods: {
        remove() {
            this.$store.dispatch('space_members/remove', {
                id: this.member.id,
            }).then(() => this.$emit('removed'));
        },
        update() {
            this.$store.dispatch('space_members/update', {
                id: this.member.id,
                data: { is_active: true, role: this.role },
            }).then(() => this.$emit('removed'));
        },
    },
};
</script>
